import { useTranslations } from '@npco/utils-translations'
import { Box } from '@npco/zeller-design-system'
import { Field } from 'formik'

import { FormCheckbox } from 'components/Input/Checkbox'

import { linkedDebitCardCheckboxTranslations } from './LinkedDebitCardCheckbox.i18n'
import * as styled from './LinkedDebitCardCheckbox.styled'

export const LinkedDebitCardCheckbox = () => {
  const t = useTranslations(linkedDebitCardCheckboxTranslations)

  return (
    <Box width="210px" mt="8px" mb="16px">
      <Field
        component={FormCheckbox}
        name="isCreateCardAllowed"
        type="checkbox"
        alignItems="end"
        justifyContent="space-between"
        flexDirection="row-reverse"
      >
        <styled.Label>{t('label')}</styled.Label>
      </Field>
    </Box>
  )
}
